<template>
	<div class="header-wrapper" style="background-color: transparent !important;">
		<!-- 顶部固定层 -->
		<div class="top-overlay" :class="{ 'show-border': showBorder, 'search-active': showSearch, 'is-fixed': fixed }"
			:style="{ backgroundColor: showSearch ? '#ffffff' : backgroundColor, color: theme === 'dark' && !showSearch ? '#ffffff' : '#000000' }"
			v-if="!menuOpen">
			<div class="top-left-nav">
				<button class="menu-btn font-bespoke" @click.stop="openMenu">Menu</button>
				<a href="#" class="login-link font-bespoke" @click.prevent="openLogin">Login</a>
			</div>
			<div class="logo-container" v-if="!showSearch && showLogo">
				<img :src="logoImage" alt="denHolm" class="logo-img" @click="goToHome" />
			</div>
			<div class="logo-container" v-else-if="showLogo || showSearch">
				<img :src="logoBlack" alt="denHolm" class="logo-img" @click="goToHome" />
			</div>
			<div class="top-right-icons">
				<button class="icon-btn" @click.stop="toggleSearch">
					<img :src="effectiveIconColor === 'white' ? require('@/assets/icon/search.png') : require('@/assets/icon/search_black.png')"
						alt="search" class="icon-img" />
				</button>
				<button class="icon-btn" @click.stop="openUserInfo">
					<img :src="effectiveIconColor === 'white' ? require('@/assets/icon/user.png') : require('@/assets/icon/user_black.png')"
						alt="user" class="icon-img" />
				</button>
				<button class="icon-btn" @click.stop="openEnquiry">
					<img :src="effectiveIconColor === 'white' ? require('@/assets/icon/product.png') : require('@/assets/icon/product_black.png')"
						alt="product" class="icon-img" />
				</button>
			</div>
		</div>

		<!-- 左侧菜单栏 -->
		<aside class="sidebar-wrap" :style="{ pointerEvents: menuOpen ? 'auto' : 'none' }">
			<Menu :isOpen="menuOpen" @close="closeMenu" @toggle-search="toggleSearch" @toggle-user-info="openUserInfo"
				@toggle-enquiry="openEnquiry" @toggle-login="openLogin" @toggle-subscribe="openEmailPopup" />
		</aside>

		<!-- 搜索框 -->
		<transition name="search-slide">
			<div v-if="showSearch" class="search-overlay" @scroll="handleScroll">
				<div class="search-container">
					<input type="text" v-model="searchQuery" placeholder="What are you looking for?"
						class="search-input font-apercu-medium" @keyup.enter="performSearch" autofocus
						@blur="handleBlur" @input="handleInput" />
					<div v-if="showSearchResult && !searchConfirmed" class="search-result-hint font-apercu-medium">
						Press enter to view all {{searchTotal}} results
					</div>
				</div>
				<!-- 显示搜索出来的商品信息 -->
				<div v-if="showSearchResult" class="search-results-grid">
					<div class="result-item" v-for="(item, index) in searchResults" :key="index">
						<div class="result-image-wrapper">
							<img :src="item.image" :alt="item.name" @click="goToProduct(item.ProductID)" />
						</div>
					</div>
				</div>

				<!-- 加载更多指示器 -->
				<div v-if="isLoadingMore" class="loading-indicator">
					Loading...
				</div>
			</div>
		</transition>

		<!-- 搜索遮罩层 -->
		<div v-if="showSearch" class="search-mask" @click="toggleSearch"></div>

		<!-- 登录组件 -->
		<Login :is-open="isLoginOpen" :initial-customer-type="loginInitialType" :initial-isregister="initialIsRegister"
			@open-email-popup="openEmailPopup" @close="closeLogin" @switch-to-menu="switchToMenu" />

		<!-- 用户信息组件 -->
		<UserInfo :is-open="isUserInfoOpen" @close="closeUserInfo" @toggle-search="toggleSearch"
			@toggle-enquiry="openEnquiry" @open-trader-login="openTraderLogin" @open-private-login="openPrivateLogin"
			@open-register="openRegister" />

		<!-- Enquiry Component -->
		<Enquiry :is-open="isEnquiryOpen" @close="closeEnquiry" @toggle-search="toggleSearch"
			@toggle-user-info="openUserInfo" />

		<!-- 邮件弹窗组件  组件挂载后延迟5m自动弹出一次-->
		<!-- <EmailPopup :visible.sync="emailPopupVisible" :auto-show-delay="autoShowDelay"/> -->
		<EmailPopup :visible.sync="emailPopupVisible" :auto-show-delay="0" @close="onEmailPopupClose" />

	</div>
</template>

<script>
	import logoBlack from '../assets/logo_b.png'
	import logoWhite from '../assets/logo_w.png'
	import Login from './Login.vue'
	import UserInfo from './UserInfo.vue'
	import Enquiry from './Enquiry.vue'
	import Menu from './Menu.vue'
	import EmailPopup from './Email.vue' // 确保路径正确

	import {
		getUser
	} from '@/config/auth'
	import {
		searchProducts
	} from '@/api/product'

	const prod1 = require('@/assets/Group 1-1.png')
	const prod2 = require('@/assets/Group 1-2.png')
	const prod3 = require('@/assets/Group 1-3.png')
	const prod4 = require('@/assets/Group 1-4.png')

	export default {
		name: 'Header',
		components: {
			Login,
			UserInfo,
			Enquiry,
			Menu,
			EmailPopup
		},
		props: {
			theme: {
				type: String,
				default: 'dark'
			},
			showBorder: {
				type: Boolean,
				default: false
			},
			iconColor: {
				type: String,
				default: 'white'
			},
			showLogo: {
				type: Boolean,
				default: true
			},
			fixed: {
				type: Boolean,
				default: false
			},
			backgroundColor: {
				type: String,
				default: 'transparent'
			}
		},
		data() {
			return {
				autoPopupTimer: null, // 自动弹窗定时器
				autoPopupShown: false, // 本次会话是否已触发过自动弹窗
				menuOpen: false,
				showSearch: false,
				searchQuery: '',
				showSearchResult: false,
				searchConfirmed: false,
				isLoadingMore: false,
				isLoginOpen: false,
				isUserInfoOpen: false,
				isEnquiryOpen: false,
				emailPopupVisible: false, // 控制邮件弹窗
				loginInitialType: 'private',
				initialIsRegister: false, // 默认登录模式
				logoBlack,
				logoWhite,
				searchResults: [{
						name: 'Product 1',
						image: prod1
					},
					{
						name: 'Product 2',
						image: prod2
					},
					{
						name: 'Product 3',
						image: prod3
					},
					{
						name: 'Product 4',
						image: prod4
					},
					{
						name: 'Product 5',
						image: prod3
					},
					{
						name: 'Product 6',
						image: prod2
					},
					{
						name: 'Product 7',
						image: prod1
					},
					{
						name: 'Product 8',
						image: prod2
					},
					{
						name: 'Product 9',
						image: prod3
					}
				],
				isAnimating: false,
				searchLoading: false,
				searchPageIndex: 1,
				searchTotal: 0,
				searchHasMore: true,
				searchResults: [] // 实际搜索结果
			}
		},
		mounted() {
			this.scheduleAutoPopup()
		},
		beforeDestroy() {
			if (this.autoPopupTimer) clearTimeout(this.autoPopupTimer)
		},
		computed: {
			isLoggedInAndSubscribed() {
				const user = getUser()
				return user && user.IsSubscribed === true
			},
			autoShowDelay() {
				// 仅在首页且未弹出过时启用自动弹窗
				return this.$route.name === 'Home' ? 5000 : 0
			},
			logoImage() {
				return this.theme === 'dark' ? this.logoWhite : this.logoBlack
			},
			effectiveIconColor() {
				return this.showSearch ? 'black' : this.iconColor
			},
			currentOpenComponent() {
				if (this.isLoginOpen) return 'login'
				if (this.isUserInfoOpen) return 'userInfo'
				if (this.isEnquiryOpen) return 'enquiry'
				if (this.showSearch) return 'search'
				if (this.menuOpen) return 'menu'
				return null
			},
			autoShowDelay() {
				// 如果当前路由是首页，返回 5000（5秒），否则返回 0（禁用自动弹出）
				return this.$route.name === 'Home' ? 5000 : 0;
			}
		},

		methods: {
			scheduleAutoPopup() {
				if (this.autoPopupTimer) clearTimeout(this.autoPopupTimer)
				const delay = this.autoShowDelay // 来自 computed
				if (delay <= 0) return

				// 永久标记（手动关闭后不再自动弹）
				const hasAutoShown = localStorage.getItem('emailAutoShown') === 'true'
				if (hasAutoShown) return
				if (this.autoPopupShown) return

				// 关键：已登录且已订阅，不弹
				if (this.isLoggedInAndSubscribed) return

				this.autoPopupTimer = setTimeout(() => {
					// 延迟后再次检查（防止期间登录订阅）
					if (this.isLoggedInAndSubscribed) return
					if (localStorage.getItem('emailAutoShown') === 'true') return
					if (!this.emailPopupVisible && !this.autoPopupShown) {
						this.emailPopupVisible = true
						this.autoPopupShown = true
					}
					this.autoPopupTimer = null
				}, delay)
			},

			onEmailPopupClose() {
				// 关闭时记录永久标记，且清除可见性
				localStorage.setItem('emailAutoShown', 'true')
				this.emailPopupVisible = false
			},

			goToHome() {
				this.$router.push({
					name: 'Home'
				})
			},
			goToProduct(productId) {
				this.$router.push({
					path: '/product/detail',
					query: {
						productId
					}
				})
			},

			// 打开邮件弹窗（由 Login 组件触发）
			openEmailPopup() {
				this.closeLogin(); // 关闭登录面板
				this.emailPopupVisible = true; // 打开邮件弹窗
			},

			closeAllComponents() {
				const component = this.currentOpenComponent
				this.isLoginOpen = false
				this.isUserInfoOpen = false
				this.isEnquiryOpen = false
				this.showSearch = false
				this.searchQuery = ''
				this.showSearchResult = false
				this.menuOpen = false

				if (!component) return Promise.resolve()
				let duration = 400
				if (component === 'enquiry' || component === 'menu' || component === 'login') duration = 800
				return new Promise(resolve => setTimeout(resolve, duration))
			},

			async openMenu() {
				if (this.isAnimating) return
				const hadOpen = !!this.currentOpenComponent
				if (hadOpen) {
					this.isAnimating = true
					await this.closeAllComponents()
				}
				this.menuOpen = true
				document.body.style.overflow = 'hidden'
				this.$emit('menu-open')
				if (hadOpen) this.isAnimating = false
			},
			closeMenu() {
				this.menuOpen = false
				document.body.style.overflow = ''
				this.$emit('menu-close')
			},

			async openLogin() {
				if (this.isAnimating) return
				const hadOpen = !!this.currentOpenComponent
				if (hadOpen) {
					this.isAnimating = true
					await this.closeAllComponents()
				}
				this.isLoginOpen = true
				document.body.style.overflow = 'hidden'
				if (hadOpen) this.isAnimating = false
			},
			closeLogin() {
				this.isLoginOpen = false
				document.body.style.overflow = ''
			},

			async openUserInfo() {
				if (this.isAnimating) return
				const hadOpen = !!this.currentOpenComponent
				if (hadOpen) {
					this.isAnimating = true
					await this.closeAllComponents()
				}
				this.isUserInfoOpen = true
				document.body.style.overflow = 'hidden'
				if (hadOpen) this.isAnimating = false
			},
			closeUserInfo() {
				this.isUserInfoOpen = false
				document.body.style.overflow = ''
			},

			async openEnquiry() {
				if (this.isAnimating) return
				const hadOpen = !!this.currentOpenComponent
				if (hadOpen) {
					this.isAnimating = true
					await this.closeAllComponents()
				}
				this.isEnquiryOpen = true
				document.body.style.overflow = 'hidden'
				if (hadOpen) this.isAnimating = false
			},
			closeEnquiry() {
				this.isEnquiryOpen = false
				document.body.style.overflow = ''
			},

			switchToMenu() {
				this.openMenu()
			},

			openTraderLogin() {
				this.loginInitialType = 'trader'
				this.openLogin()
			},
			openPrivateLogin() {
				this.loginInitialType = 'private'
				this.openLogin()
			},
			openRegister() {
				this.initialIsRegister = true
				this.loginInitialType = 'private' // 可根据需求调整
				this.openLogin()
			},

			async toggleSearch() {
				if (this.isAnimating) return
				if (this.showSearch) {
					this.showBorder = false
					this.showSearch = false
					this.showSearchResult = false
					this.searchConfirmed = false
					document.body.style.overflow = ''
					this.menuOpen = false
				} else {
					const hadOpen = !!this.currentOpenComponent
					if (hadOpen) {
						this.isAnimating = true
						await this.closeAllComponents()
					}
					this.showBorder = false
					this.showSearch = true
					this.showSearchResult = false
					this.searchConfirmed = false
					document.body.style.overflow = 'hidden'
					if (hadOpen) this.isAnimating = false
				}
			},

			handleInput() {
				this.showSearchResult = false
				this.searchConfirmed = false
			},

			async performSearch() {
				if (!this.searchQuery.trim()) return
				this.searchResults = []
				this.searchPageIndex = 1
				this.searchHasMore = true
				this.showSearchResult = true
				this.searchConfirmed = true
				await this.fetchSearchResults(this.searchQuery, 1)
			},

			async fetchSearchResults(keyword, pageIndex) {
				this.searchLoading = true
				try {
					const response = await searchProducts({
						keyword,
						pageIndex,
						pageSize: 20000
					})
					if (response.retCode === 1) {
						const products = response.result || []
						const total = response.totalCount || 0
						this.searchTotal = total
						this.searchConfirmed = false
						const formatted = products.map(p => ({
							ProductID: p.ProductID,
							name: p.ProductName,
							image: p.Images.find(img => img.IsPrimary).ImageURL || p.Images[0].ImageURL ||
								''
						}))
						if (pageIndex === 1) {
							this.searchResults = formatted
						} else {
							this.searchResults = [...this.searchResults, ...formatted]
						}
						this.searchHasMore = this.searchResults.length < total
						this.searchPageIndex = pageIndex
					}
				} catch (error) {
					console.error('Search error:', error)
				} finally {
					this.searchLoading = false
				}
			},

			handleBlur() {
				this.showSearchResult = this.searchQuery !== ''
			},

			handleScroll(e) {
				if (!this.showSearchResult || this.isLoadingMore) return
				const {
					scrollTop,
					clientHeight,
					scrollHeight
				} = e.target
				if (scrollHeight - scrollTop - clientHeight < 100) {
					this.loadMoreResults()
				}
			},

			async loadMoreResults() {
				if (!this.searchHasMore || this.searchLoading || !this.searchQuery) return
				const nextPage = this.searchPageIndex + 1
				await this.fetchSearchResults(this.searchQuery, nextPage)
			}
		}
	}
</script>


<style scoped>
	/* 样式保持不变 */
	.header-wrapper {
		position: relative;
		width: 100%;
		height: 123rem;
	}

	.icon-img {
		width: 22rem;
		height: 22rem;
	}

	.top-overlay {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		height: 123rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 40rem;
		z-index: 100;
		transition: border-bottom 0.3s ease, background-color 0.3s ease, color 0.3s ease;
	}

	.top-overlay.is-fixed {
		position: fixed;
		width: 100%;
	}

	.top-overlay.search-active {
		background-color: #ffffff;
		border: none;
		height: 123rem;
		position: fixed;
	}

	.search-mask {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background-color: rgba(0, 0, 0, 0.5);
		z-index: 90;
	}

	.top-overlay.search-active .menu-btn {
		color: #000000;
	}

	.top-overlay.search-active .login-link {
		color: #000000;
	}

	.top-overlay.search-active .icon-btn {
		color: #000000;
	}

	.top-overlay.show-border {
		border-bottom: 1rem solid #000;
	}

	.top-overlay>* {
		pointer-events: auto;
	}

	.top-left-nav {
		display: flex;
		gap: 30rem;
		align-items: center;
	}

	.menu-btn {
		background: none;
		border: none;
		color: inherit;
		font-size: 20rem;
		font-weight: 400;
		cursor: pointer;
		padding: 0;
		transition: opacity 0.3s;
	}

	.menu-btn:hover {
		opacity: 0.7;
	}

	.login-link {
		color: inherit;
		text-decoration: none;
		font-size: 20rem;
		font-weight: 400;
		transition: opacity 0.3s;
	}

	.login-link:hover {
		opacity: 0.7;
	}

	.logo-container {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.logo-img {
		width: 172rem;
		height: 20rem;
		margin-top: 15rem;
		cursor: pointer;
	}

	.top-right-icons {
		display: flex;
		gap: 23rem;
		align-items: center;
	}

	.icon-btn {
		background: none;
		border: none;
		cursor: pointer;
		color: inherit;
		padding: 8rem;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: opacity 0.3s;
	}

	.icon-btn:hover {
		opacity: 0.7;
	}

	.search-overlay {
		position: fixed;
		top: 120rem;
		left: 0;
		right: 0;
		z-index: 99;
		background: white;
		padding: 30rem 0;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		border-bottom: 1rem solid #000;
		max-height: calc(100vh - 120rem);
		overflow-y: auto;
	}

	.search-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100%;
		max-width: 600rem;
	}

	.search-input {
		font-size: 24rem;
		font-weight: 500;
		width: 100%;
		font-family: inherit;
		height: 50rem;
		line-height: 50rem;
		outline: none;
		border: none;
		border-bottom: 1rem solid #000;
		background: transparent;
		text-align: left;
		padding: 0;
	}

	.search-result-hint {
		width: 100%;
		text-align: left;
		margin-top: 10rem;
		font-size: 16rem;
		color: #000;
		display: flex;
		align-items: center;
	}

	.red-arrow {
		color: red;
		margin-right: 8rem;
		font-size: 10rem;
	}

	.search-results-grid {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		width: 100%;
		margin-top: 40rem;
	}

	.result-item {
		width: 100%;
	}

	.result-image-wrapper {
		width: 100%;
		height: 378rem;
		aspect-ratio: 1;
		background-color: #f5f5f5;
		overflow: hidden;
	}

	.result-image-wrapper img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.loading-indicator {
		width: 100%;
		text-align: center;
		padding: 20rem;
		font-size: 16rem;
		color: #666;
	}

	@media (max-width: 768px) {
		.top-overlay {
			padding: 20rem;
		}

		.top-overlay.search-active {
			height: 100rem;
		}

		.search-overlay {
			top: 100rem;
			padding: 20rem 0;
		}

		.top-left-nav {
			gap: 15rem;
		}

		.top-right-icons {
			gap: 10rem;
		}

		.search-input {
			width: 180rem;
		}

		.logo-img {
			width: 120rem;
			height: auto;
			margin-top: 0;
		}
	}

	.menu-backdrop {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background-color: rgba(0, 0, 0, 0.3);
		z-index: 999;
		cursor: pointer;
	}

	.search-slide-enter-active,
	.search-slide-leave-active {
		transition: transform 0.4s ease, opacity 0.4s ease;
	}

	.search-slide-enter,
	.search-slide-leave-to {
		transform: translateY(-100%);
		opacity: 0;
	}

	.sidebar-wrap {
		position: fixed;
		top: 0;
		left: 0;
		width: 35%;
		height: 100vh;
		z-index: 1000;
		overflow: hidden;
	}

	@media (max-width: 1024px) {
		.sidebar-wrap {
			width: 40%;
		}
	}

	@media (max-width: 768px) {
		.sidebar-wrap {
			width: 100%;
		}
	}

	@media (max-width: 768px) and (min-width: 481px) {
		.sidebar-wrap {
			width: 50%;
		}
	}
</style>